module.exports = __webpack_public_path__ + "img/icon-add-custom-cashback.820abfd8.svg";